(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'BucketText',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.TextSelection.initRecipients(form.name, 'travel_summaries');
	};
}(jQuery, window.Adzuki || {}));
